export default "__VITE_ASSET__CecGZM2c__"